export interface InitParams {
  apiKey: string;
}

export function init(params: InitParams): void {
  window.smartbot = window.smartbot || [];
  window.smartbot.push(params);

  window.__smartbotOnLoad = function () {
    const first = window.smartbot?.[0];
    const initFn = window.smartbotWidgetInit;

    if (typeof initFn === 'function' && first) {
      initFn(first);
    }
  };
}
